
import React from 'react';

interface FooterStripProps {
  showBranding?: boolean;
}

export function FooterStrip({ showBranding = true }: FooterStripProps) {
  if (!showBranding) {
    return null;
  }
  
  return (
    <div className="bg-muted py-2 mt-8">
      <div className="container mx-auto px-4 text-center text-sm text-muted-foreground">
        Powered by <span className="font-medium">Showee</span>
      </div>
    </div>
  );
}
